/* template */
<template><page><base-container><div :class='["btn-item"]'><cube-basic-picker/></div><div :class='["btn-item"]'><cube-slot-picker/></div></base-container></page></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_11f31eca"}'>
.btn-item
  margin-bottom 15px
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_11f31eca"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_11f31eca"}
  /** script content **/
  require("./index.mpx.js?isPage!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=page&index=0&isPage&lang=js&mpx&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_11f31eca"],
    ctorType: "page",
    outputPath: "",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'base-container':getComponent(require("../../components/base-container/index.mpx?isComponent&outputPath=components%2Findexa53ae8d2%2Findex")),'cube-basic-picker':getComponent(require("./basic-picker.mpx?isComponent&outputPath=components%2Fbasic-picker87cc6bdc%2Findex")),'cube-slot-picker':getComponent(require("./slot-picker.mpx?isComponent&outputPath=components%2Fslot-picker152c2006%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>